import * as React from 'react';
import * as styles from './styles.css';
import { IconMail } from '../icons';
export function SubscribeLink(_ref) {
  var onClick = _ref.onClick;
  return React.createElement("div", {
    key: "subscribe",
    className: styles['subscribe-link'],
    onClick: onClick
  }, React.createElement("span", null, React.createElement(IconMail, null), " \u0421\u043B\u0435\u0434\u0438\u0442\u044C \u0437\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435\u043C \u0446\u0435\u043D\u044B"));
}